import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getAllEducationsForPersons = detailed => dispatch => {
  dispatch({ type: "GET_ALL_EDUCATIONS_LOADING" });
  api
    .educationsGetAllForPersons(detailed)
    .then(resp => {
      dispatch(operationSucceeded(resp.data));
      dispatch({ type: "GET_ALL_EDUCATIONS_LOADING_DONE" });
    })
    .catch(e => {
      jsError(e);
      dispatch({ type: "GET_ALL_EDUCATIONS_LOADING_DONE" });
      dispatch(operationFail());
      dispatch(buildAlertWithLocalizedMessages(
        "ERROR",
        "GetAllEducationsErrorAlertTitle",
        "Virhe tutkintojen haussa",
        e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
    });
};

const operationSucceeded = data => ({
  type: "GET_ALL_EDUCATIONS_SUCCEEDED",
  payload: { educations: data },
});

const operationFail = () => ({
  type: "GET_ALL_EDUCATIONS_FAIL",
});
